import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { AuthService } from '../../../core/services/auth/auth.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import {
  MatCard,
  MatCardHeader,
  MatCardModule,
  MatCardTitle,
} from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { ClientCreateComponent } from '../client-create/client-create.component'
import { LegalEntityClientComponent } from '../../../pages/customer/legal-entity-client/legal-entity-client.component'
import { MatTab } from '@angular/material/tabs'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { CnpjPipe } from '../../../shared/pipes/cpnj.pipes'
import { ClientService } from '../../../core/services/customer/client/client.service'

@Component({
  selector: 'modal-delete-client',
  imports: [
    MatProgressBar,
    MatCardModule,
    MatIcon,
    MatButton,
    MatProgressSpinner,
    CnpjPipe,
  ],
  templateUrl: './modal-delete-client.component.html',
  styleUrl: './modal-delete-client.component.scss',
  standalone: true,
  providers: [LegalEntityClientService],
})
export class ModalDeleteClientComponent implements OnInit {
  constructor(
    private clienteService: ClientService,
    // private legalEntityClientService: LegalEntityClientService,
    private dialogRef: MatDialogRef<ModalDeleteClientComponent>,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    this.typeClient = data.typeClient
    console.log('data: ', data)
  }
  @Output() responseDelete = new EventEmitter()

  loading: boolean = false

  item: any = {}
  typeClient: 'client' | 'subClient' | '' = ''

  ngOnInit() {}

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
    }
  }

  deleteItem() {
    this.loading = true
    this.clienteService.deleteClient(this.item.id).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.responseDelete.emit({ delete: true })
        this.close()
      },
      error: (err: PagedContactTypeResponse) => {
        this.snackbar.errorRequest(err)
        this.responseDelete.emit({ delete: false })
        this.close()
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
